(function () {
  function init() {
    // Mobile only — desktop keeps its current behaviour
    if (window.matchMedia('(min-width: 768px)').matches) return;

    var cards = document.querySelectorAll('.hero-custom__benefit');
    if (!cards.length) return;

    // No IntersectionObserver → leave cards fully visible (no animation, no hidden state)
    if (!('IntersectionObserver' in window)) return;

    cards.forEach(function (card) {
      card.classList.add('has-scroll-anim');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -40px 0px' }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
